import React from 'react';
import ReplyMessageField from '../../templates/ReplyMessageField';

export default function ReplyNodeEditor({ body, onBodyChange, error }) {
  return (
    <ReplyMessageField
      label="Comment reply text"
      value={body}
      onChange={onBodyChange}
      error={error}
    />
  );
}
